const AuthFooter = () => (
  <div className="text-center text-sm text-white z-10 leading-6">
    ©{new Date().getFullYear()} ReEquip. All rights reserved. <br />
    <a href="" className="hover:underline">
      Terms & Conditions
    </a>{" "}
    ·{" "}
    <a href="" className="hover:underline">
      Privacy Policy
    </a>
  </div>
);

export default AuthFooter;
